import React, {Component} from "react";

import axios from 'axios';
import Constants from '../../../components/Constants/';
import {
    Row,
    Col,
    Button,
    Label,
    Input,
    Link,
    Table,
    Badge
} from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import AlertContainer from 'react-alert';

class Diagnostics extends Component {

  constructor(props) {
    super(props);

    this.refreshDiagnosticsList = this.refreshDiagnosticsList.bind(this);
    this.afterSaveCell = this.afterSaveCell.bind(this);
    this.onAddDiagnostic = this.onAddDiagnostic.bind(this);
    this.categoryFormatter = this.categoryFormatter.bind(this);

    this.state = {
        diagnosticsList: null,
        activePage: 1,
        categories: null,
        categoriesList: null
      };

      /*
      * Configurações do alerta
      */
      this.alertOptions = {
        offset: 14,
        position: 'top right',
        theme: 'light',
        time: 10000,
        transition: 'scale'
      }


      axios({
          method: 'get',
          url: Constants.apiUrl+'/api/v1/category'
      })
      .then(response => {

        let categoriesList = [];
        response.data.forEach(function(category) {
          categoriesList.push(
            {
              value: category.id,
              text: category.description
            }
          );
        });

        this.setState({
            categoriesList: categoriesList,
            categories: response.data
        });
      });


      this.refreshDiagnosticsList();
    }

    refreshDiagnosticsList(){
      axios({
          method: 'get',
          url: Constants.apiUrl+'/api/v1/diagnostic'
      })
      .then(response => {
          this.setState({
              diagnosticsList: response.data
          });
      });
    }

    statusFormatter(cell, row){
      return (
        cell == "ACTIVE" ? <Badge color="success">Ativo</Badge> : <Badge color="danger">Inativo</Badge>
      );
    }

    categoryFormatter(cell, row){
      let txt = " - ";
      if(cell)
      this.state.categoriesList.forEach(function(category) {
        if(category.value === cell.id){
          txt = category.text;
        }
      });

      return (txt);
    }

    renderPaginationShowsTotal(start, to, total) {
      return (
        <p>
          Exibindo de { start } a { to }, total: { total }
        </p>
      );
    }

    afterSaveCell(row, cellName, cellValue) {
      row.category = {
        'id': row.category
      };

      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/diagnostic',
          data: row
      })
      .then(response => {
        this.msg.show('Diagnóstico salvo.', {
          time: 10000,
          type: 'success'
        });
      });
    }

    onAddDiagnostic(row) {

      row.id = null;
      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/diagnostic',
          data: row
      })
      .then(response => {
          this.msg.show('Diagnóstico adicionado.', {
            time: 10000,
            type: 'success'
          });
          this.refreshDiagnosticsList();
      });
    }

    createCustomModalHeader(closeModal, save){
      return (
        <InsertModalHeader
          className='model-header'
          title=''
         />
      );
    }


    render() {
      if(this.state.diagnosticsList == null) return null;
      if(this.state.categoriesList == null) return null;

      const tableOptions = {
        paginationSize: 10,
        hideSizePerPage: true,
        paginationShowsTotal: true,
        paginationShowsTotal: this.renderPaginationShowsTotal,
        onAddRow: this.onAddDiagnostic,
        insertModalHeader: this.createCustomModalHeader
      };

      const statusTypes = [ {
        value: 'ACTIVE',
        text: 'Ativo'
      }, {
        value: 'INACTIVE',
        text: 'Inativo'
      }];

      const cellEdit = {
        mode: 'dbclick',
        blurToSave: true,
        afterSaveCell: this.afterSaveCell,
      };

      return(
          <div>
            <h2>Diagnósticos</h2>
            <hr />
            <BootstrapTable ref="table" data={this.state.diagnosticsList} version='4'
              striped hover pagination insertRow search searchPlaceholder='Pesquisa Geral'
              options={tableOptions} cellEdit={ cellEdit }>
              <TableHeaderColumn dataField="description" dataSort={true} width='20%'>Descrição</TableHeaderColumn>
              <TableHeaderColumn dataField="details" editable={{type: 'textarea'}} dataSort={true} width='30%'>Detalhes</TableHeaderColumn>
              <TableHeaderColumn dataField="category" editable={ { type: 'select', options: { values: this.state.categoriesList } } } dataFormat={this.categoryFormatter} dataSort={true} width='20%'>Categoria</TableHeaderColumn>

              <TableHeaderColumn dataField="status" editable={ { type: 'select', options: { values: statusTypes } } } dataFormat={this.statusFormatter} dataSort={true} width='5%'>Status</TableHeaderColumn>
              <TableHeaderColumn dataField="id" autoValue isKey={true} width='15%'>ID</TableHeaderColumn>
              <TableHeaderColumn dataField="order" dataSort={true} width='5%'>Ordem</TableHeaderColumn>

            </BootstrapTable>
            <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />
            <br />
          </div>
        )
    }
}

export default Diagnostics;



// WEBPACK FOOTER //
// ./src/views/admin/Diagnostics/Diagnostics.js